export interface RumConfig {
  appMonitorId: string;
  identityPoolId: string;
  guestRoleArn: string;
  region: string;
}

interface AppSettings {
  apiUrl: string;
  stage: string;
  rum?: RumConfig;
}

// Settings injected at deploy time via settings.json
let settings: AppSettings | null = null;

/** True only when actually served from a local dev server. */
function isLocalDev(): boolean {
  return (
    typeof window !== 'undefined' && /^(localhost|127\.0\.0\.1)$/.test(window.location.hostname)
  );
}

export async function getSettings(): Promise<AppSettings> {
  if (settings) return settings;

  try {
    const res = await fetch('/settings.json');
    if (!res.ok) throw new Error(`settings.json returned ${res.status}`);
    settings = await res.json();
    return settings!;
  } catch (e) {
    // The localhost fallback must apply ONLY on localhost. Previously any
    // transient failure to load settings.json pointed the deployed SPA at
    // http://localhost:3001, which the browser then blocked as mixed content —
    // surfacing as an unintelligible "Failed to fetch" with no request ever
    // leaving the page. Worse, the fallback was cached in `settings`, so one
    // blip poisoned every subsequent call for the rest of the session.
    if (isLocalDev()) {
      settings = { apiUrl: 'http://localhost:3001', stage: 'local' };
      return settings;
    }
    // Deployed: fail loudly and do NOT cache, so a retry can recover.
    throw new Error(
      `Could not load settings.json, so the API endpoint is unknown: ${(e as Error).message}`,
    );
  }
}
